import React from 'react';

// Star rating component with native SVG stars

interface StarRatingProps {
  rating: number;
  onRatingChange?: (rating: number) => void;
  readonly?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const StarRating: React.FC<StarRatingProps> = ({
  rating,
  onRatingChange,
  readonly = false,
  size = 'md',
  className = '',
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
  };

  const handleClick = (newRating: number) => {
    if (!readonly && onRatingChange) {
      onRatingChange(newRating);
    }
  };

  const handleMouseEnter = (newRating: number) => {
    if (!readonly) {
      const stars = document.querySelectorAll('[data-star-rating]');
      stars.forEach((star, index) => {
        if (index < newRating) {
          star.classList.add('text-yellow-400');
          star.classList.remove('text-gray-300');
        } else {
          star.classList.add('text-gray-300');
          star.classList.remove('text-yellow-400');
        }
      });
    }
  };

  const handleMouseLeave = () => {
    if (!readonly) {
      const stars = document.querySelectorAll('[data-star-rating]');
      stars.forEach((star, index) => {
        if (index < rating) {
          star.classList.add('text-yellow-400');
          star.classList.remove('text-gray-300');
        } else {
          star.classList.add('text-gray-300');
          star.classList.remove('text-yellow-400');
        }
      });
    }
  };

  return (
    <div
      className={`flex items-center space-x-1 ${className}`}
      onMouseLeave={handleMouseLeave}
    >
      {[1, 2, 3, 4, 5].map((starNumber) => (
        <button
          key={starNumber}
          type="button"
          data-star-rating
          className={`${sizeClasses[starNumber]} ${
            readonly ? 'cursor-default' : 'cursor-pointer hover:scale-110'
          } transition-all duration-200 p-1 ${
            starNumber <= rating
              ? 'text-yellow-400'
              : 'text-gray-300'
          }`}
          onClick={() => handleClick(starNumber)}
          onMouseEnter={() => handleMouseEnter(starNumber)}
          disabled={readonly}
          >
          <span className={`${sizeClasses[starNumber]} ${
            starNumber <= rating
              ? 'text-yellow-400'
              : 'text-gray-300'
          }`}>
            {starNumber <= rating ? '★' : '☆'}
          </span>
        </button>
      ))}
    </div>
  );
};

export default StarRating;